class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    document.querySelectorAll('[id*="cart-icon-bubble"]').forEach((cartLink) => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    })
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('active');
      this.classList.add('animate');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    if(document.querySelectorAll('.popup-modal.active').length == 0){
      // Save current scroll position
      const scrollY = window.scrollY;
      document.body.setAttribute('data-scroll-position', scrollY);
      document.documentElement.setAttribute('data-scroll-position', scrollY);
      
      // Add classes to prevent scrolling
      document.body.classList.add('cart-drawer-open', 'overflow-hidden');
      document.documentElement.classList.add('cart-drawer-open');
      
      // Set padding to prevent layout shift
      document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
      
      // Set top position to maintain scroll position
      document.body.style.top = `-${scrollY}px`;
    }
  }

  close() {
    this.classList.remove('animate');
    setTimeout(() => {
      this.classList.remove('active');
      if(document.querySelectorAll('.popup-modal.active').length == 0){
        // Remove classes
        document.body.classList.remove('cart-drawer-open', 'overflow-hidden');
        document.documentElement.classList.remove('cart-drawer-open');
        
        // Restore scroll position
        const scrollY = document.body.getAttribute('data-scroll-position') || document.documentElement.getAttribute('data-scroll-position') || '0';
        document.body.removeAttribute('data-scroll-position');
        document.documentElement.removeAttribute('data-scroll-position');
        document.body.style.top = '';
        document.body.style.paddingRight = '';
        
        // Restore scroll position
        window.scrollTo(0, parseInt(scrollY, 10));
      }
    }, 500);
    removeTrapFocus(this.activeElement);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if(sectionElement) sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if(section.id == 'cart-free-delivery' && document.querySelector('#product-page-free-delivery')){
        document.querySelector('#product-page-free-delivery').innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
      if(section.id == 'cart-icon-bubble' && document.querySelector('.footer-sticky-nav__item__icon .cart-count-bubble')){
        const parser = new DOMParser();
        const bubble = parser.parseFromString(this.getSectionInnerHTML(parsedState.sections[section.id], section.selector), 'text/html');
        var ib = bubble.querySelector('.cart-count-bubble')?bubble.querySelector('.cart-count-bubble').innerHTML : '' ;
        document.querySelector('.footer-sticky-nav__item__icon .cart-count-bubble').innerHTML = ib;
      }
    });

    setTimeout(() => {
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-icon-bubble--mobile'
      },
      {
        id: 'cart-free-delivery'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble--mobile',
        section: 'cart-icon-bubble--mobile',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


/* ------------------------------------------ */
/* Gift Config                                */
/* ------------------------------------------ */

const GIFT_VARIANTS = [
  47234772107431,
  47311960899751
];

// Tier base choices (distinct IDs only)
const VARIANTS_BY_TOTAL = {
  700: [47234772107431],                        // Tier1: 1 distinct gift
  1000: [47234772107431, 47311960899751]         // Tier2: 2 distinct gifts
};

const TIER1_CENTS = 700 * 100;
const TIER2_CENTS = 1000 * 100;

function distinctGiftsForTier(subtotalCents) {
  if (subtotalCents >= TIER2_CENTS) {
    const set = Array.from(new Set(VARIANTS_BY_TOTAL[1000] || []));
    return set.slice(0, 2);
  }
  if (subtotalCents >= TIER1_CENTS) {
    const set = Array.from(new Set(VARIANTS_BY_TOTAL[700] || []));
    return set.slice(0, 1);
  }
  return []; // tier0
}


/* ------------------------------------------ */
/* Cart Tier Status (tier0 aware)             */
/* ------------------------------------------ */

function getCartTierStatus(cartTotalPrice) {
  const subtotalCents = cartTotalPrice;

  if (subtotalCents >= TIER2_CENTS) {
    return { tier: 'tier2', minAmount: TIER2_CENTS / 100, gifts: distinctGiftsForTier(subtotalCents) };
  } else if (subtotalCents >= TIER1_CENTS) {
    return {
      tier: 'tier1',
      minAmount: TIER1_CENTS / 100,
      maxAmount: (TIER2_CENTS - 1) / 100,
      gifts: distinctGiftsForTier(subtotalCents)
    };
  } else {
    return {
      tier: 'tier0',
      nextTierAmount: TIER1_CENTS / 100,
      neededAmount: (TIER1_CENTS - subtotalCents) / 100,
      gifts: [] // tier0 => cleanup
    };
  }
}

// Track current tier for external reads
let currentCartTier = 'tier0';


/* ------------------------------------------ */
/* Helpers                                    */
/* ------------------------------------------ */

async function fetchCart() {
  try {
    const res = await fetch('/cart.js');
    if (!res.ok) throw new Error('Failed to fetch cart');
    const cart = await res.json();
    const tierStatus = getCartTierStatus(cart.total_price);
    currentCartTier = tierStatus.tier;
    console.log(`🔄 Cart Tier: ${currentCartTier} | Total: $${(cart.total_price / 100).toFixed(2)}`);
    return cart;
  } catch (error) {
    console.error('Error fetching cart:', error);
    return null;
  }
}

function isFreeGiftLine(line) {
  if (!GIFT_VARIANTS.includes(line.variant_id)) return false;
  return (
    line.final_line_price === 0 ||
    (line.discounted_price === 0 && line.quantity > 0) ||
    (line.line_price === 0 && line.original_line_price === 0)
  );
}
function isGiftVariantLine(line) { return GIFT_VARIANTS.includes(line.variant_id); }

function toCountsDistinctOneEach(arr) {
  const m = {};
  for (const id of Array.from(new Set(arr))) m[id] = 1; // qty=1 per gift
  return m;
}

function collectFreeGiftLines(cart) {
  return cart.items
    .map((line, idx) => ({ id: line.id, key: line.key, variant_id: line.variant_id, quantity: line.quantity, index: idx, _raw: line }))
    .filter(l => isFreeGiftLine(l._raw));
}
function collectAnyGiftLines(cart) {
  return cart.items
    .map((line, idx) => ({ id: line.id, key: line.key, variant_id: line.variant_id, quantity: line.quantity, index: idx, _raw: line }))
    .filter(l => isGiftVariantLine(l._raw));
}

function pickVariantToAddAvoidingDuplicates(cart, preferredId) {
  const presentVariants = new Set(collectAnyGiftLines(cart).map(l => l.variant_id));
  if (!presentVariants.has(preferredId)) return preferredId;
  for (const id of GIFT_VARIANTS) { if (!presentVariants.has(id)) return id; }
  return preferredId;
}


/* ------------------------------------------ */
/* Validation & Guards (existence only)       */
/* ------------------------------------------ */

let DISABLE_UPSELL = false;               // disables adds/trim for tier1/2, not tier0 cleanup
let ENSURE_RUNNING = false;               // 🔒 re-entrancy lock
const ADD_DEBOUNCE_MS = 2500;             // ⏱️ per-variant add debounce
const _recentAdds = new Map();            // variantId -> timestamp (ms)
const _variantCheckCache = new Map();

function _isValidVariantId(id) { return Number.isInteger(id) && id > 0; }

/** /variants/:id.js -> { exists } */
async function checkVariantExists(variantId) {
  if (_variantCheckCache.has(variantId)) return _variantCheckCache.get(variantId);
  if (!_isValidVariantId(variantId)) {
    const out = { exists: false };
    _variantCheckCache.set(variantId, out);
    return out;
  }
  try {
    const res = await fetch(`/variants/${variantId}.js`, { method: 'GET' });
    const ok = res.ok;
    const out = { exists: ok };
    if (ok) await res.json(); // warm cache; price is irrelevant
    _variantCheckCache.set(variantId, out);
    return out;
  } catch {
    const out = { exists: false };
    _variantCheckCache.set(variantId, out);
    return out;
  }
}


/* ------------------------------------------ */
/* Cart API Operations                        */
/* ------------------------------------------ */

async function addVariantsInBatch(items) {
  if (!items || !items.length) return null;
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) throw new Error('Failed to add items');
    return await res.json();
  } catch (error) {
    console.error('Error adding items:', error);
    return null;
  }
}

async function updateCartItems(updates) {
  if (!updates.length) return null;
  try {
    const updatesData = { updates: {} };
    updates.forEach(u => { updatesData.updates[u.id] = u.quantity; });
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(updatesData)
    });
    if (!res.ok) throw new Error('Failed to update cart');
    return await res.json();
  } catch (error) {
    console.error('Error updating cart:', error);
    return null;
  }
}


/* ------------------------------------------ */
/* Tier0 cleanup: remove ALL gift lines       */
/* ------------------------------------------ */

async function removeAllGiftVariantLines(cart) {
  const giftLines = cart.items
    .map((line) => ({ id: line.id, variant_id: line.variant_id, quantity: line.quantity }))
    .filter(l => GIFT_VARIANTS.includes(l.variant_id));
  if (!giftLines.length) return;
  const updates = giftLines.map(l => ({ id: l.id, quantity: 0 }));
  await updateCartItems(updates);
}


/* ------------------------------------------ */
/* Main Gift Enforcement Logic                */
/* ------------------------------------------ */

async function ensureGiftsForTiers() {
  if (ENSURE_RUNNING) return;
  ENSURE_RUNNING = true;

  try {
    let cart = await fetchCart();
    if (!cart) return;

    const tierStatus = getCartTierStatus(cart.total_price);

    /* ---- Tier0: ALWAYS clean up gift lines (free or paid) ---- */
    if (tierStatus.tier === 'tier0') {
      await removeAllGiftVariantLines(cart);
      return; // UI refresh in finally
    }

    if (DISABLE_UPSELL) return;

    // Validate existence only (discount engine will make them free)
    let neededGiftIds = tierStatus.gifts || [];
    if (!neededGiftIds.length) return;

    // ***** UPDATED BEHAVIOR: skip only invalid IDs instead of disabling *****
    const existsChecks = await Promise.all(neededGiftIds.map(id => checkVariantExists(id)));
    const validIds = neededGiftIds.filter((id, i) => existsChecks[i] && existsChecks[i].exists);

    // If none valid, do nothing this run (keep upsell enabled for future runs)
    if (!validIds.length) return;

    currentCartTier = tierStatus.tier;

    // Desired: distinct gifts, qty=1 each
    const desiredCounts = toCountsDistinctOneEach(validIds);

    // A) Normalize ANY gift lines to desired set (qty=1) and remove undesired
    const freeGiftLines = collectFreeGiftLines(cart);
    const updates = [];
    for (const line of freeGiftLines) {


      const vid = line.variant_id;
      const want = desiredCounts[vid] || 0;   // 1 or 0
      const targetQty = want ? 1 : 0;
      if (line.quantity !== targetQty) {
        updates.push({ id: line.id, quantity: targetQty });
      }
    }
    if (updates.length) {
      await updateCartItems(updates);
      cart = await fetchCart();
      if (!cart) return;
    }

    // B) Add any missing gifts (avoid duplicates; count ANY gift lines present)
    const anyGiftLines = collectAnyGiftLines(cart);
    const presentSet = new Set(anyGiftLines.map(l => l.variant_id));

    const toAdd = [];
    for (const vid of Object.keys(desiredCounts).map(Number)) {
      if (presentSet.has(vid)) continue; // already have it (free or paid)
      const now = Date.now();
      const last = _recentAdds.get(vid) || 0;
      if (now - last < ADD_DEBOUNCE_MS) continue; // debounce
      const chosen = pickVariantToAddAvoidingDuplicates(cart, vid);
      if (!toAdd.includes(chosen)) toAdd.push(chosen);
      _recentAdds.set(vid, now);
    }

    if (toAdd.length) {
      const itemsToAdd = toAdd.map(id => ({ id, quantity: 1 }));
      await addVariantsInBatch(itemsToAdd);
    }

  } catch (e) {
    console.warn('ensureGiftsForTiers soft error:', e);
  } finally {
    updateCartDrawer();
    ENSURE_RUNNING = false;
  }
}


/* ------------------------------------------ */
/* Event Wiring                               */
/* ------------------------------------------ */

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(ensureGiftsForTiers, 500);
});
document.addEventListener('cart:request-completed', ensureGiftsForTiers);

// AJAX interception
(function patchAjaxCartMutations() {
  const origFetch = window.fetch;
  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : input.url;
    const isCartMutation = url && (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    );
    const result = await origFetch.apply(this, arguments);
    if (isCartMutation) {
      if (!ENSURE_RUNNING) setTimeout(ensureGiftsForTiers, 120);
    }
    return result;
  };
})();

/* Theme drawer refresh hook */
function updateCartDrawer() {
  const cartDrawer = document.querySelector('m-cart-drawer');
  if (cartDrawer && typeof cartDrawer.onCartDrawerUpdate === 'function') {
    cartDrawer.onCartDrawerUpdate(true);
  }
}


/* ------------------------------------------ */
/* Export for External Use                    */
/* ------------------------------------------ */

window.cartTier = {
  getCurrentTier: () => currentCartTier,          // 'tier0' | 'tier1' | 'tier2'
  recompute: ensureGiftsForTiers,
  disableUpsell: () => { DISABLE_UPSELL = true; },
  enableUpsell: () => { DISABLE_UPSELL = false; }
};

// Optional CommonJS export
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    ensureGiftsForTiers,
    fetchCart,
    getCartTierStatus,
    currentCartTier
  };
}
